import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { MatTooltip } from '@angular/material/tooltip';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import { getSourceStatusClassName, SOURCE_STATUS_TO_LABEL, SourceStatus } from '@examdojo/source';
import { ReferenceQuestionViewHttpModel } from '@examdojo/reference-question';

@Component({
  selector: 'exam-reference-question-list-source-status-cell-renderer',
  template: `
    @if (status) {
      <div
        [ngClass]="statusClass"
        class="inline-flex max-w-full overflow-hidden rounded-[6px] px-1.5 py-1 text-xs font-semibold"
      >
        <span class="truncate" [matTooltip]="statusLabel">{{ statusLabel }}</span>
      </div>
    }
  `,
  standalone: true,
  imports: [MatTooltipTruncateDirective, MatTooltip, NgClass],
})
export class ReferenceQuestionListSourceStatusCellRendererComponent extends BaseCellRendererComponent<
  SourceStatus | null,
  ReferenceQuestionViewHttpModel
> {
  get status(): SourceStatus | null {
    const rawStatus = this.params?.data?.source_status;
    return rawStatus ? (rawStatus as SourceStatus) : null;
  }

  get statusClass(): string {
    return getSourceStatusClassName(this.status);
  }

  get statusLabel(): string {
    return SOURCE_STATUS_TO_LABEL[this.status!] ?? '';
  }
}
